<div class="fullcontainer">
  <br />
  <br />
  <div class='titleContainer'>
    <h2 class='header' style='color:#006598;'>Picking Slips</h2>
    <div>
      <button class='btn btn-secondary' routerLink='/delivery-notes'><i class="fas fa-truck-loading"></i> Delivery Notes</button>
    </div>
  </div>
  <p class='text-muted'>Delivery notes that are ready to pick or part picked. Pick opens the slip with suggested locations; confirming books the stock out.</p>
  @if (this.error) { <div class='alert alert-danger'>{{ this.error }}</div> }
  <app-grid
    entity='delivery-note'
    [filters]='this.filters'
    [columns]='this.columns'
    [buttons]='this.buttons'
    [searchFilters]='this.searchFilters'
    [searchFields]='this.searchFields'
    sortColumn='requiredDate'
    sortDirection='asc'
  ></app-grid>
</div>
